<!-- 原料商品操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <subComponents ref="showSelectData"></subComponents>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm && tabForm.length">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box" v-if="scope.row && scope.row.jurconfigform">
                                <el-form label-width="150px" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                    <el-row>
                                        <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                            <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, message: '不能为空', trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 系统字段 -->
                                                <template v-if="formOneValue.isReserved == 0">
                                                    <el-select v-if="formOneValue.entityField == 'stId'" v-model="sendDataInfo[formOneValue.entityField]" clearable placeholder="请选择库房">
                                                        <el-option v-for="(storageRoomValue, storageRoomKey) in storageRoomList" :key="storageRoomKey" :label="storageRoomValue.stName" :value="storageRoomValue.stId">
                                                        </el-option>
                                                    </el-select>
                                                    <el-input v-else-if="formOneValue.entityField == 'rmmRemarks'" type="textarea" :rows="3" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                                        placeholder="请输入备注"></el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'rmpMinilength'" v-model.trim="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'rmpMiniwidth'" v-model.trim="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'rmpMiniheight'" v-model.trim="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'rmpMinivolume'" v-model.trim="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">立方厘米（cm3）</template>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'rmpMiniweight'" v-model.trim="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">克（g）</template>
                                                    </el-input>
                                                    <!-- 税务分类名称 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'rmfTaxname'" filterable v-model="sendDataInfo[formOneValue.entityField]" @change="taxChange"
                                                        :disabled="formOneValue.isChange == 0">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.swflmc" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <el-select clearable size="mini" filterable v-else-if="formOneValue.fieldType == 'formatter'" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value"></el-option>
                                                    </el-select>
                                                    <el-input v-else-if="formOneValue.entityField=='rmfTaxnumber'" disabled clearable v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                    <el-input v-else clearable v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" placeholder="请输入"></el-input>
                                                </template>
                                                <!-- 扩展字段 -->
                                                <template v-else-if="formOneValue.isReserved == 1">
                                                    <el-input v-if="formOneValue.operatType == 0" clearable v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" placeholder="请输入">
                                                    </el-input>
                                                    <el-input v-else readonly v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" placeholder="请选择"
                                                        @focus="$refs['showSelectData'].openBox(formOneValue.dsmName, formOneValue.entityField, formOneValue.dsmField)">
                                                        <el-button slot="append" icon="el-icon-search" @click="$refs['showSelectData'].openBox(formOneValue.dsmName, formOneValue.entityField, formOneValue.dsmField)"></el-button>
                                                    </el-input>
                                                </template>
                                            </el-form-item>
                                        </template>
                                    </el-row>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <el-button type="primary" @click="initActionBox">取消</el-button>
                    <el-button type="primary" :loading="submitLoading" @click="sendDataAction" v-if="dataActionBox.actionType == 0">保存</el-button>
                    <el-button type="primary" :loading="submitLoading" @click="sendDataAction" v-if="dataActionBox.actionType == 1">保存</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'rawProductsAction',
    props: ['actionData'],
    data() {
        return {
            isLoaded: false,
            submitLoading: false,
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0,
            },
            showTabs: '',
            sendDataInfo: {
                rmfIntaxrate: 0,
                rmfOuttaxrate: 0,
                rmfReserves1: "",
                rmfReserves2: "",
                rmfReserves3: "",
                rmfReserves4: "",
                rmfReserves5: "",
                rmfReserves6: "",
                rmfTaxname: "",
                rmfTaxnumber: "",
                rmmBarcode: "",
                rmmCreater: 0,
                rmmManufacturer: "",
                rmmMnemonic: "",
                rmmName: "",
                rmmPlaceorigin: "",
                rmmRemarks: "",
                rmmReserves1: "",
                rmmReserves2: "",
                rmmReserves3: "",
                rmmReserves4: "",
                rmmReserves5: "",
                rmmReserves6: "",
                rmmSpecifications: "",
                rmpColor: "",
                rmpMiniheight: 0,
                rmpMinilength: 0,
                rmpMinivolume: 0,
                rmpMiniweight: 0,
                rmpMiniwidth: 0,
                rmpReserves1: "",
                rmpReserves2: "",
                rmpReserves3: "",
                rmpReserves4: "",
                rmpReserves5: "",
                rmpReserves6: "",
                rmpSituation: "",
                rmpUnitmeasurement: "",
                stId: 0
            },
            storageRoomList: [],
            formDataList: [],
            tabForm: [],
            mxForm: [],
            footForm: [],
            dictionariesData: {},
        };
    },
    watch: {
        "sendDataInfo.rmmName"() {
            this.sendDataInfo.rmmMnemonic = this.$common.createPinyinCode(this.sendDataInfo.rmmName, this.sendDataInfo.rmmMnemonic)
        },
    },
    methods: {
        //税务名称改变
        taxChange(data) {
            console.log("data", data);
            for (let i = 0; i < this.dictionariesData.swflmc.length; i++) {
                const item = this.dictionariesData.swflmc[i];
                if (item.diName == data) {
                    this.sendDataInfo.rmfTaxnumber = item.diCode;
                    break;
                }
            }
        },
        isShowData(name, value) {
            this.sendDataInfo[name] = value
        },
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            this.tabForm = []
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) {
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                    }
                }
            })
            if (this.tabForm.length > 0) {
                this.showTabs = this.tabForm[0].jciName
            }
        },
        fillEditData(oldData) {
            let dataInfo = JSON.parse(JSON.stringify(oldData))
            let packing = oldData.packing || {}
            let finance = oldData.finance || {}
            delete dataInfo.packing
            delete dataInfo.finance
            let newDataInfo = Object.assign({}, packing, finance, dataInfo)
            for (let key in newDataInfo) {
                this.$set(this.sendDataInfo, key, newDataInfo[key])
            }
            for (let key in this.sendDataInfo) {
                if (this.sendDataInfo[key] == null) this.sendDataInfo[key] = ""
            }
        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = ''
            }
            this.sendDataInfo.rmmCreater = this.$store.getters.getUserInfo.opmId
            this.sendDataInfo.rmfIntaxrate = 0
            this.sendDataInfo.rmfOuttaxrate = 0
        },
        initActionBox() {
            this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.init()
                this.$emit('drawerCancel')
            }).catch(() => { })
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData || []
            this.showTabs = this.formDataList.length > 0 ? this.formDataList[0].jciName : ''
            var oldData = this.actionData.oldData
            this.filterMainField()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'rtl'
                if (oldData) {
                    this.fillEditData(oldData)
                }
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                if (oldData) {
                    this.fillEditData(oldData)
                }
            }
            this.dataActionBox.showStatus = true
        },
        async sendDataAction() {
            if (this.sendDataInfo.rmmName == '') {
                this.$message({
                    message: '请填写名称',
                    type: 'error'
                });
                return false
            }
            this.submitLoading = true
            try {
                let responseData
                if (this.dataActionBox.actionType == 0) {
                    responseData = await this.$http.addRawProduct(this.sendDataInfo)
                } else {
                    let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
                    sendData.rmmrModifyer = this.$store.getters.getUserInfo.depId
                    responseData = await this.$http.editRawProduct(sendData)
                }
                if (responseData.status == 200) {
                    this.init()
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.$emit('drawerCancel')
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            } finally {
                this.submitLoading = false
            }
        },
        async getAllStorageRoom() {
            let responseData = await this.$http.getAllStorageRoom()
            if (responseData.status == 200) {
                this.storageRoomList = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [14, 10, 9, 25, 11, 13, 5, 30, 39, 41, 42, 43, 58, 61, 62, 65, 70, 71],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    created() {
        this.getAllStorageRoom()
        this.getPartDictionariesData()
        this.$nextTick(() => {
            this.openBox()
            this.isLoaded = true
        })
    },
}
</script>

<style scoped>
.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.foots {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    border-top: 1px solid #e4e7ed;
    background: #fff;
}
</style>
